import PropTypes from 'prop-types';
// material
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
// components
import CartVoucherStatus from './CartVoucherStatus';

const RootStyle = styled('div')(({ theme }) => ({
  marginBottom: '16px',
  borderRadius: '16px',
  paddingTop: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  border: `1px dashed ${grey[300]}`
}));

CartVoucher.propTypes = {
  voucher: PropTypes.object
};

export default function CartVoucher({ voucher }) {
  if (voucher && voucher.code) {
    return (
      <RootStyle>
        <Box display="flex" alignItems="center" pb={1} mb={1}>
          <Box flexGrow={1}>
            <Typography variant="body1" component="p" color="textSecondary">
              Voucher
            </Typography>
          </Box>
          <Box mr={1}>
            <Typography align="right" variant="body1" component="p">
              {voucher.code}
            </Typography>
          </Box>
          <CartVoucherStatus voucher={voucher} />
        </Box>
      </RootStyle>
    );
  }

  return <></>;
}
